export const state = () => ({
	about_me: null,
	interests: null,
	fluent_languages: null,
});

export const mutations = {
	setAboutMe(state: any, payload: any) {
		state.about_me = payload;
	},
	setInterests(state: any, payload: any) {
		state.interests = payload;
	},
	setFluentLanguages(state: any, payload: any) {
		state.fluent_languages = payload;
	},
};

export const getters = {
	getAboutMe: (state: any) => state.about_me,
	getInterests: (state: any) => state.interests,
	getFluentLanguages: (state: any) => state.fluent_languages,
};

export const actions = {
	async updateUserInformation(state: any, payload: any) {
		let user = {
			name: this.$auth.user.name,
			surname: this.$auth.user.surname,
			phone: this.$auth.user.phone,
			gender_pronoun: payload.gender_pronoun,
			dob: this.$auth.user.dob,
			id_number: payload.id_number || this.$auth.user.id_number,
			email: this.$auth.user.email,
		};

		Object.keys(user).forEach((key) => {
			if (user[key] === null) {
				delete user[key];
			}
		});

		return new Promise((resolve, reject) => {
			this.$axios
				.put('/user/information', user)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async getAllFluentLanguages(state: any, payload: any) {
		if (!state.state.fluent_languages) {
			return new Promise((resolve, reject) => {
				this.$axios
					.get('/api/dd/fluent-languages')
					.then((res) => {
						state.commit('setFluentLanguages', res.data);
						resolve(res);
					})
					.catch((err) => {
						reject(err);
					});
			});
		} else {
			return new Promise((resolve, reject) => {
				resolve(state.state.fluent_languages);
			});
		}
	},

	async getAllInterests(state: any, payload: any) {
		if (!state.state.interests) {
			return new Promise((resolve, reject) => {
				this.$axios
					.get('/api/dd/interests')
					.then((res) => {
						state.commit('setInterests', res.data);
						resolve(res);
					})
					.catch((err) => {
						reject(err);
					});
			});
		} else {
			return new Promise((resolve, reject) => {
				resolve(state.state.interests);
			});
		}
	},

	async updateProfile(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/profile', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updateProfilePicture(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/profile/picture', payload)
				.then((res) => {
					this.$auth.setUser({
						...this.$auth.user,
						profile_picture: res.data.profile_picture,
					});

					state.dispatch(
						'profile/progress/updateProfileProgress',
						{ add_profile_picture: true },
						{ root: true },
					);

					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async deleteProfilePicture(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete('/api/profile/picture')
				.then((res) => {
					this.$auth.setUser({
						...this.$auth.user,
						profile_picture: null,
					});

					state.dispatch(
						'profile/progress/updateProfileProgress',
						{ add_profile_picture: false },
						{ root: true },
					);

					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateAboutMe(state: any, payload: any) {
		state.commit('setAboutMe', payload);
	},

	updateInterests(state: any, payload: any) {
		state.commit('setInterests', payload);
	},
};
